import {
  Button,
  Checkbox,
  Dropdown,
  InputGroup,
  InputGroupPrepend,
  InputGroupText,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextInput
} from '@met/react-components';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { adminActions } from '../../store';

const currencyOptions = [
  { label: 'USD', value: 'USD' },
  { label: 'CAD', value: 'CAD' }
];

const emptyForm = {
  locationId: '',
  squareLocationId: '',
  allowTestCards: false,
  adyenMerchantAccount: '',
  adyenPosMerchantAccount: '',
  adyenStoreId: '',
  adyenCurrencyCode: 'USD'
};

const AddAdyenLocationModal = ({ isOpen, onClose, onCreated }) => {
  const dispatch = useDispatch();
  const isSaving = useSelector(state => state.admin.createAdminLocation.isLoading);
  const [form, setForm] = useState(emptyForm);

  const updateForm = (key, value) => setForm(current => ({ ...current, [key]: value }));

  const handleClose = () => {
    setForm(emptyForm);
    onClose();
  };

  const handleSubmit = event => {
    event.preventDefault();
    const request = {
      ...form,
      locationId: form.locationId.trim(),
      squareLocationId: form.squareLocationId.trim(),
      adyenMerchantAccount: form.adyenMerchantAccount.trim(),
      adyenPosMerchantAccount: form.adyenPosMerchantAccount.trim(),
      adyenStoreId: form.adyenStoreId.trim()
    };

    if (!request.locationId || !request.squareLocationId || !request.adyenMerchantAccount) {
      toastr.error('Validation error', 'Location ID, Square Location ID, and Adyen Merchant Account are required.');
      return;
    }

    dispatch(adminActions.createAdminLocation(request))
      .then(() => {
        setForm(emptyForm);
        onCreated(request.locationId);
      })
      .catch(error => {
        if (error?.status === 409) {
          toastr.error('Location already exists', `Location ${request.locationId} already exists.`);
          return;
        }
        toastr.error('Error: Add location', 'Could not create the Adyen location.');
      });
  };

  return (
    <Modal centered hidden={!isOpen} toggle={handleClose}>
      <ModalContent>
        <ModalHeader toggle={handleClose}>Add Adyen Location</ModalHeader>
        <form onSubmit={handleSubmit}>
          <ModalBody>
            <InputGroup>
              <InputGroupPrepend><InputGroupText>Location ID</InputGroupText></InputGroupPrepend>
              <TextInput
                value={form.locationId}
                maxLength={100}
                onChange={event => updateForm('locationId', event.target.value)}
              />
            </InputGroup>
            <InputGroup>
              <InputGroupPrepend><InputGroupText>Square Location ID</InputGroupText></InputGroupPrepend>
              <TextInput
                value={form.squareLocationId}
                maxLength={100}
                onChange={event => updateForm('squareLocationId', event.target.value)}
              />
            </InputGroup>
            <InputGroup>
              <InputGroupPrepend><InputGroupText>Adyen Merchant Account</InputGroupText></InputGroupPrepend>
              <TextInput
                value={form.adyenMerchantAccount}
                maxLength={100}
                onChange={event => updateForm('adyenMerchantAccount', event.target.value)}
              />
            </InputGroup>
            <InputGroup>
              <InputGroupPrepend><InputGroupText>POS Merchant Account</InputGroupText></InputGroupPrepend>
              <TextInput
                value={form.adyenPosMerchantAccount}
                maxLength={100}
                onChange={event => updateForm('adyenPosMerchantAccount', event.target.value)}
              />
            </InputGroup>
            <InputGroup>
              <InputGroupPrepend><InputGroupText>Adyen Store ID</InputGroupText></InputGroupPrepend>
              <TextInput
                value={form.adyenStoreId}
                maxLength={100}
                onChange={event => updateForm('adyenStoreId', event.target.value)}
              />
            </InputGroup>
            <InputGroup>
              <InputGroupPrepend><InputGroupText>Currency</InputGroupText></InputGroupPrepend>
              <Dropdown
                options={currencyOptions}
                getOptionValue={option => option.value}
                getOptionLabel={option => option.label}
                value={form.adyenCurrencyCode}
                onChange={option => updateForm('adyenCurrencyCode', option?.value || 'USD')}
              />
            </InputGroup>
            <Checkbox
              id='adyen-location-test-cards'
              label='Allow test cards'
              checked={form.allowTestCards}
              onCheck={({ checked }) => updateForm('allowTestCards', checked)}
            />
          </ModalBody>
          <ModalFooter>
            <Button secondary loading={isSaving} onClick={handleClose}>Cancel</Button>
            <Button primary type='submit' loading={isSaving}>Add location</Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default AddAdyenLocationModal;